import ToastMessage from "../../common/ToastMessage";
import client from "../client";

const listName = "DigitalSignature";

class DigitalSignatureService {
  async SignDocument(Path: string) {
    try {
      const { data } = await client.post<any[]>(
        `/api/${listName}/SignDocument`,
        {
          Path,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      let err = error as any;
      ToastMessage.Failed(err?.response.data);
      throw error;
    }
  }

  async GetUserDigitalSignature(userId: string) {
    try {
      const { data } = await client.get<any[]>(
        `/api/${listName}/GetUserSignature/${userId}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async SignedDocument(documentId: string) {
    try {
      const { data } = await client.get<any[]>(
        `/api/${listName}/SignedDocument/${documentId}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new DigitalSignatureService();
